import GenericFilter from "./GenericFilter";
import ProductListing from "./ProductListing";
import React, { Component } from "react";
import UrlFilterHelper from "./UrlFilterHelper";
import AppliedFilters from "./AppliedFilters";
import Spinner from "./Spinner";
import { updateProductGroupItemList } from "./SchemaOrgGraph";

class ProductFilter extends Component {
  constructor(props) {
    super(props);
    this.url = i18n.baseUrl + "api/productfilter/search";

    this.state = {
      error: false,
      loading: true,
      products: [],
      filterGroups: [],
      totalMatching: 0,
    };
    this.bindThis();
    this.filterHelper = new UrlFilterHelper();
  }

  bindThis() {
    // Make 'this' work in event functions
    this.onFilterChanged = this.onFilterChanged.bind(this);
  }

  componentDidMount() {
    this.getData(this.filterHelper.getFilters());
  }

  getData(filters) {
    fetch(this.url, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        code: this.props.productAreaCode,
        selectedFilters: filters,
      }),
    })
      .then((data) => data.json())
      .then(
        (data) => {
          this.filterHelper.setFilters(data.filters || []);
          updateProductGroupItemList(data.items);

          this.setState({
            filterGroups: data.filters || [],
            products: data.items || [],
            totalMatching: data.totalMatching || 0,
            loading: false,
            error: false,
          });
        },
        (error) => {
          this.setState({
            error: true,
            loading: false,
          });
        }
      );
  }

  onFilterChanged() {
    let appliedFilters = [];
    this.state.filterGroups.forEach((filterGroup) => {
      let selectedItems = filterGroup.items.filter((item) => item.selected);
      if (selectedItems.length) {
        // Create a copy so we don't mess with the filters applied
        let filterGroupCopy = {};
        Object.assign(filterGroupCopy, filterGroup);
        filterGroupCopy.items = selectedItems;
        appliedFilters.push(filterGroupCopy);
      }
    });

    this.getData(appliedFilters);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="c-product-overview">
          <h2>{i18n.getString("generalError")}</h2>
        </div>
      );
    } else if (this.state.loading) {
      return <Spinner />;
    }

    return (
      <>
        <div className="c-product-overview">
          <div className="c-product-filter row">
            <GenericFilter onFilterChanged={this.onFilterChanged} filterGroups={this.state.filterGroups} />
          </div>
        </div>
        <AppliedFilters
          filterGroups={this.state.filterGroups}
          onCleared={this.onFilterChanged}
          onFilterRemoved={this.onFilterChanged}
        />
        <ProductListing
          items={this.state.products}
          expandText={i18n.getString("productFilter.expandTechnicalData")}
          heading={i18n.getString("productFilter.productListingHeader")}
          totalMatching={this.state.totalMatching}
        />
      </>
    );
  }
}

export default ProductFilter;
